import authService from './auth';
import practitionerService from './practitioner';
import bookingSlotService from './bookingSlot';
import accountService from './account';
import appointmentService from './appointment';
import onlineService from './onlineService';
import preferredSiteService from './preferredSite';
import caseService from './case';
import viewBookingsService from './viewBookings';

import * as localStorage from './localStorage';

export {
  authService,
  practitionerService,
  bookingSlotService,
  accountService,
  appointmentService,
  onlineService,
  preferredSiteService,
  localStorage,
  caseService,
  viewBookingsService,
};
